import {
  getKeyDataPointsParams,
  KEY_DATA_POINT_VALUES,
} from 'spw-components/dialogs/total-program/utils';
import { TableBody, TableHead, TableRow } from '@mui/material';
import {
  DataPointsCell,
  DataPointsCellHeader,
  DataPointsCellSubHeader,
  DeltaValue,
  ScenarioName,
  DepartmentName,
  DeptSecondaryIdentifier,
  DialogTable,
} from 'spw-components/dialogs/total-program/styles';
import React from 'react';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { PlainWorksheet } from '../../../models/Worksheet';

export const ProgramSummaryDialogTable = ({
  value,
  valueType,
  totalProgramWorksheets,
}: {
  value: number | string;
  valueType: string;
  totalProgramWorksheets: PlainWorksheet[];
}) => {
  const { convertArea, getUnit } = useUnitConversion();
  const headerValues = getKeyDataPointsParams(
    valueType,
    getUnit('area'),
    convertArea
  );

  if (!headerValues) return null;

  const {
    header,
    title,
    valueFormatter: formatValue,
    valueGetter,
  } = headerValues;
  const headerValue = formatValue?.(value as number);

  return (
    <DialogTable>
      <TableHead>
        <TableRow className="scenario-name-row">
          <DataPointsCellHeader width="60%">Scenario Name</DataPointsCellHeader>
        </TableRow>
        <TableRow className="department-name-row">
          <DataPointsCellHeader>Department Name</DataPointsCellHeader>
          <DataPointsCellHeader align="right">{header}</DataPointsCellHeader>
        </TableRow>
        <TableRow>
          <DataPointsCellSubHeader>{title}</DataPointsCellSubHeader>
          <DataPointsCellSubHeader align="right">
            {valueType === KEY_DATA_POINT_VALUES.DELTA ? (
              <DeltaValue
                className={
                  typeof value === 'number' && value > 0
                    ? 'positive'
                    : 'negative'
                }
              >
                {headerValue}
              </DeltaValue>
            ) : (
              headerValue
            )}
          </DataPointsCellSubHeader>
        </TableRow>
      </TableHead>

      <TableBody>
        {totalProgramWorksheets.map((worksheet) => {
          const { scenario } = worksheet;
          const { department, name } = scenario;
          const scenarioValue = valueGetter?.(worksheet);
          return (
            <TableRow key={`row-${scenario.id}`}>
              <DataPointsCell>
                <ScenarioName>{name}</ScenarioName>
                <DepartmentName>{department.name}</DepartmentName>
                <DeptSecondaryIdentifier>
                  {department.secondaryIdentifier}
                </DeptSecondaryIdentifier>
              </DataPointsCell>
              <DataPointsCell align="right">
                {valueType === KEY_DATA_POINT_VALUES.DELTA ? (
                  <DeltaValue
                    className={scenarioValue > 0 ? 'positive' : 'negative'}
                  >
                    {formatValue(scenarioValue)}
                  </DeltaValue>
                ) : (
                  formatValue(scenarioValue)
                )}
              </DataPointsCell>
            </TableRow>
          );
        })}
      </TableBody>
    </DialogTable>
  );
};
